const KeenSlider = window.KeenSlider

const { setInitialised, useDots, addWheelControls } =
  window.BAO.Carousel.plugins

class StickyCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    if (!this.els.slide?.exists) return

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: true,
        mode: 'snap',
        slides: {
          origin: 'center',
          perView: 1.8,
          spacing: 8,
        },
        breakpoints: {
          '(min-width: 901px)': {
            slides: {
              origin: 'center',
              perView: 2,
              spacing: 8,
            },
          },
          '(min-width: 1440px)': {
            slides: {
              origin: 'center',
              perView: 2.2,
              spacing: 8,
            },
          },
        },
      },
      [
        setInitialised(),
        useDots({
          dots: this.els?.dot?.elements,
          container: this.els['dot-container']?.element,
        }),
        addWheelControls('horizontal'),
      ],
    )
  }
}

if (!customElements.get('sticky-carousel')) {
  customElements.define('sticky-carousel', StickyCarousel)
}
